import { menuTypeDict } from '@/dictionary/menu'
import { companyTypeDict } from '@/dictionary/company'
import {
  platformFunctionModuleDict,
  workbenchServiceDict
} from '@/dictionary/system'

/**
 * 专家管理
 */
export default {
  path: 'expert',
  type: menuTypeDict.DIRECTORY.value,
  meta: {
    title: '专家管理',
    layout: 'DefaultLayout'
  },
  applicableCompanyTypes: [
    { companyType: companyTypeDict.ENTERPRISE.value },
    { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
  ],
  platformAlias: [],
  applicableCompanyIdentities: [
    workbenchServiceDict.PURCHASER.value,
    workbenchServiceDict.AGENCY.value
  ],
  roles: [
    platformFunctionModuleDict.EXPERT_MANAGEMENT.right,
    platformFunctionModuleDict.EXPERT_EXTRACTION.right,
    platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
  ],
  superviseInstitutions: [],

  children: [
    // 专家入库审核
    {
      path: 'audit',
      type: menuTypeDict.DIRECTORY.value,
      meta: {
        title: '专家入库审核',
        icon: 'icon-side_expert_audit',
        layout: 'DefaultLayout'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [
        workbenchServiceDict.PURCHASER.value,
        workbenchServiceDict.AGENCY.value
      ],
      roles: [
        platformFunctionModuleDict.EXPERT_MANAGEMENT.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: [],

      children: [
        // 审核列表
        {
          path: 'list',
          name: 'ExpertAuditList',
          component: '/expert-views/audit',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '审核列表',
            cache: true,
            hidden: true,
            pageComponentName: 'ExpertAuditList'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [
            workbenchServiceDict.PURCHASER.value,
            workbenchServiceDict.AGENCY.value
          ],
          roles: [
            platformFunctionModuleDict.EXPERT_MANAGEMENT.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 入库审核
        {
          path: ':approvalId/detail',
          name: 'ExpertAuditDetail',
          component: '/expert-views/audit/detail',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '入库审核',
            hidden: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [
            workbenchServiceDict.PURCHASER.value,
            workbenchServiceDict.AGENCY.value
          ],
          roles: [
            platformFunctionModuleDict.EXPERT_MANAGEMENT.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        }
      ]
    },

    // 专家维护
    {
      path: 'manage',
      type: menuTypeDict.DIRECTORY.value,
      meta: {
        title: '专家维护',
        icon: 'icon-side_expert_maintain',
        layout: 'DefaultLayout'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [
        workbenchServiceDict.PURCHASER.value,
        workbenchServiceDict.AGENCY.value
      ],
      roles: [
        platformFunctionModuleDict.EXPERT_MANAGEMENT.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: [],

      children: [
        // 专家列表
        {
          path: 'list',
          name: 'ExpertList',
          component: '/expert-views/expert',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '专家列表',
            cache: true,
            hidden: true,
            pageComponentName: 'ExpertList'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [
            workbenchServiceDict.PURCHASER.value,
            workbenchServiceDict.AGENCY.value
          ],
          roles: [
            platformFunctionModuleDict.EXPERT_MANAGEMENT.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 新增专家
        {
          path: 'add',
          name: 'ExpertAdd',
          component: '/expert-views/expert/add',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '新增专家',
            hidden: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [
            workbenchServiceDict.PURCHASER.value,
            workbenchServiceDict.AGENCY.value
          ],
          roles: [
            platformFunctionModuleDict.EXPERT_MANAGEMENT.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 编辑专家
        {
          path: ':expertId/edit',
          name: 'ExpertEditInfo',
          component: '/expert-views/expert/edit',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '编辑专家',
            hidden: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [
            workbenchServiceDict.PURCHASER.value,
            workbenchServiceDict.AGENCY.value
          ],
          roles: [
            platformFunctionModuleDict.EXPERT_MANAGEMENT.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 专家详情
        {
          path: 'detail/:expertId/info',
          name: 'ExpertDetailInfo',
          component: '/expert-views/expert/detail',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '专家详情',
            hidden: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [
            workbenchServiceDict.PURCHASER.value,
            workbenchServiceDict.AGENCY.value
          ],
          roles: [
            platformFunctionModuleDict.EXPERT_MANAGEMENT.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        }
      ]
    },

    // 专业维护
    {
      path: 'major',
      name: 'ExpertMajor',
      component: '/expert-views/major',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '专业维护',
        icon: 'icon-side_expert_profession'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [
        workbenchServiceDict.PURCHASER.value,
        workbenchServiceDict.AGENCY.value
      ],
      roles: [
        platformFunctionModuleDict.EXPERT_MANAGEMENT.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 专家抽取
    {
      path: 'extract',
      type: menuTypeDict.DIRECTORY.value,
      meta: {
        title: '专家抽取',
        icon: 'icon-side_expert_extract',
        layout: 'DefaultLayout'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [
        workbenchServiceDict.PURCHASER.value,
        workbenchServiceDict.AGENCY.value
      ],
      roles: [
        platformFunctionModuleDict.EXPERT_EXTRACTION.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: [],

      children: [
        // 抽取列表
        {
          path: 'list',
          name: 'ExpertExtract',
          component: '/expert-views/extract',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '抽取列表',
            cache: true,
            hidden: true,
            pageComponentName: 'ExpertExtract'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [
            workbenchServiceDict.PURCHASER.value,
            workbenchServiceDict.AGENCY.value
          ],
          roles: [
            platformFunctionModuleDict.EXPERT_EXTRACTION.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 抽取数据登记
        {
          path: 'register',
          name: 'ExpertExtractRegister',
          component: '/expert-views/extract/register',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '抽取数据登记',
            hidden: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [
            workbenchServiceDict.PURCHASER.value,
            workbenchServiceDict.AGENCY.value
          ],
          roles: [
            platformFunctionModuleDict.EXPERT_EXTRACTION.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 通知状态
        {
          path: 'notice/:extractId/info',
          name: 'ExpertExtractNotice',
          component: '/expert-views/extract/notice',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '通知状态',
            hidden: true
          },
          applicableCompanyTypes: [
            {
              companyType: companyTypeDict.ENTERPRISE.value,
              menuName: '抽取详情'
            },
            {
              companyType: companyTypeDict.PUBLIC_INSTITUTION.value,
              menuName: '抽取详情'
            }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [
            workbenchServiceDict.PURCHASER.value,
            workbenchServiceDict.AGENCY.value
          ],
          roles: [
            platformFunctionModuleDict.EXPERT_EXTRACTION.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 抽取详情
        {
          path: 'detail/:extractId/info',
          name: 'ExpertExtractDetail',
          component: '/expert-views/extract/detail',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '抽取详情',
            hidden: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [
            workbenchServiceDict.PURCHASER.value,
            workbenchServiceDict.AGENCY.value
          ],
          roles: [
            platformFunctionModuleDict.EXPERT_EXTRACTION.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 修改到场状态
        {
          path: 'change/:extractId/abnormal/:childExtractId?',
          name: 'ExpertExtractAbnormal',
          component: '/expert-views/extract/abnormal',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '修改到场状态',
            hidden: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [
            workbenchServiceDict.PURCHASER.value,
            workbenchServiceDict.AGENCY.value
          ],
          roles: [
            platformFunctionModuleDict.EXPERT_EXTRACTION.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        }
      ]
    }
  ]
}
